import { Component, Input } from '@angular/core';
import { openClose } from '@core/animations/animations';
import { ICON } from '@core/util/icon';
import {
	MatterRequisitionPrecedent,
	MatterRequisitionPrecedentStatuses,
	RequisitionFieldTypes,
} from '@models/requisitions';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { RequisitionService } from '@services/requisition.service';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterRequisitionsDispatch } from '@state/matter/requisitions/matter-requisitions.dispatch';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { TestHooks } from './requisition-precedent-data.hooks';

@Component({
	selector: 'app-requisition-precedent-data',
	templateUrl: 'requisition-precedent-data.component.html',
	animations: [openClose(300)],
	standalone: false,
})
export class RequisitionPrecedentDataComponent {
	testHooks = TestHooks;
	@SelectSnapshot(SelectedMatter.id) public matterId: string;
	public ICON = ICON;
	public open = false;
	public valueTypes = RequisitionFieldTypes;
	public requisitionStatuses = MatterRequisitionPrecedentStatuses;

	@Input() set requisition(requisition: MatterRequisitionPrecedent) {
		this._requisition = requisition;
		this.getPopulatedText()
			.pipe(take(1))
			.subscribe((parsedText) => {
				this.requisitionParsedText = parsedText?.replace(/\n/g, '<br>');
			});
	}

	get requisition(): MatterRequisitionPrecedent {
		return this._requisition;
	}

	private _requisition: MatterRequisitionPrecedent;
	public requisitionParsedText: string;

	constructor(
		private requisitionDispatch: MatterRequisitionsDispatch,
		private requisitionService: RequisitionService,
	) {}

	toggleOpen() {
		this.open = !this.open;
	}

	getPopulatedText(): Observable<string> {
		return this.requisitionService
			.getPopulatedText(this.requisition?.text, this.requisition?.fields)
			.pipe(take(1));
	}

	onStatusChange(status: MatterRequisitionPrecedentStatuses) {
		this.updateRequisition({ status });
	}

	onFulfilledChange(fulfilled: boolean): void {
		this.updateRequisition({ fulfilled });
	}

	onDischargedInstrumentNumberChange(dischargedInstrumentNumber: string): void {
		this.updateRequisition({ dischargedInstrumentNumber });
	}

	onRegisteredOnDateChange(registeredOnDate: string): void {
		this.updateRequisition({ registeredOnDate });
	}

	private updateRequisition(
		requisitionUpdate: Partial<MatterRequisitionPrecedent>,
	) {
		if (!this.requisition?.id) return;
		this.requisitionDispatch.Update(this.requisition.id, requisitionUpdate);
	}
}
